import { Divider, Input, Stack } from '@chakra-ui/react';
import { ChangeEvent, RefObject, useCallback, useEffect } from 'react';
import { useSearchBox } from 'react-instantsearch-core';
import { useDebounce } from 'usehooks-ts';

type Props = {
  query: string;
  placeholder: string;
  setQuery: (query: string) => void;
  refineSearch?: boolean;
  initialFocusRef: RefObject<HTMLInputElement>;
};

// Search bar to be used in InstantSearch components. (AirlinePicker, AirportPicker, etc.)
export const Search = ({ query, placeholder, setQuery, refineSearch = true, initialFocusRef }: Props) => {
  // initialFocusRef is a normal prop (not forwarded) since it is used in Input not the Search component

  const { refine } = useSearchBox();
  const debouncedQuery = useDebounce(query, 300);

  useEffect(() => {
    if (refineSearch) refine?.(debouncedQuery);
  }, [debouncedQuery, refineSearch, refine]);

  const handleSearchChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => setQuery(event.target.value),
    [setQuery],
  );

  return (
    <Stack direction="row" w="full" pb={4}>
      <Stack direction="row" align="center" flex="1">
        <Divider orientation="vertical" borderWidth="1px" borderColor="secondary" h="16px" opacity="1" />
        <Input
          placeholder={placeholder}
          _placeholder={{
            color: 'text.placeholder',
          }}
          variant="unstyled"
          value={query}
          onChange={handleSearchChange}
          autoComplete="off"
          ref={initialFocusRef}
        />
      </Stack>
    </Stack>
  );
};
